import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common Functions
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
//import * as c from "../../common/AppConstants";
import * as fo from "../../common/FormatFunctions";

export class Stock extends Component {
  constructor() {
    super();
    this.state = {
      //Loading
      loaded: false,
      editLoaded: true,
      //Display
      stockSelected: false,
      stockEdited: false,
      stockAdded: false,
      stockDeleted: false,
      //Details
      stockList: [],
      selectedStock: "",
      stockCategory: "",
      stockCodeTag: "",
      stockDescription: "",
      stockId: "",
      stockLastUpdatedDateTime: "",
      stockQuantity: "",
      stockStockCode: "",
      stockType: "",
      stockUserId: "",
      //Edit Details
      editedStockCategory: "",
      editedStockDescription: "",
      editedStockQuantity: "",
      editedStockStockCode: "",
      editedStockType: ""
      //Other
    };
  }

  componentDidMount = () => {
    this.getStock();
  };

  getStock = async () => {
    let stockRequest = new CloudService.StockRequest();
    stockRequest.codeTag = localStorage.getItem("codeTag");
    stockRequest.userId = localStorage.getItem("userId");

    await api("stockApiV1StockGetByCodeTag", stockRequest).then(res => {
      if (res.data.stockList) {
        res.data.stockList.forEach(e => {
          if (e.lastUpdatedDateTime) {
            e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
          }
        });
      }

      let stockResponse = CloudService.StockResponse.constructFromObject(
        res.data
      );
      console.log(stockResponse);

      if (stockResponse.errorCode === 0) {
        this.setState(
          {
            stockList: stockResponse.stockList || []
          },
          () => {
            console.log(this.state.stockList);
            this.reselectStock();
          }
        );
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving stock, please refresh and try again",
          life: 3000
        });
      }
    });

    this.setState({ loaded: true, editLoaded: true });
  };

  updateStock = async () => {
    this.setState({ editLoaded: false });

    let stockRequest = new CloudService.StockRequest();
    stockRequest.codeTag = localStorage.getItem("codeTag");
    stockRequest.userId = localStorage.getItem("userId");
    stockRequest.id = this.state.stockId;
    stockRequest.lastUpdatedDateTime = this.state.stockLastUpdatedDateTime;
    stockRequest.stockCode = this.state.editedStockStockCode;
    stockRequest.description = this.state.editedStockDescription;
    stockRequest.category = this.state.editedStockCategory;
    stockRequest.type = this.state.editedStockType;
    stockRequest.quantity = this.state.editedStockQuantity;

    await api("stockApiV1StockUpdate", stockRequest).then(res => {
      if (res.data.lastUpdatedDateTime) {
        res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
      }

      let stockResponse = CloudService.StockResponse.constructFromObject(
        res.data
      );
      console.log(stockResponse);

      if (stockResponse.errorCode === 0) {
        this.setState({
          stockEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Stock successfully updated",
          life: 3000
        });
        let typeOfUpdate = 1;
        this.updateStockList(stockResponse, typeOfUpdate);
      } else {
        this.setState({ editLoaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the stock, please try again",
          life: 3000
        });
      }
    });
  };

  addStock = async () => {
    this.setState({ editLoaded: false });

    let stockRequest = new CloudService.StockRequest();
    stockRequest.codeTag = localStorage.getItem("codeTag");
    stockRequest.userId = localStorage.getItem("userId");
    stockRequest.stockCode = this.state.editedStockStockCode;
    stockRequest.description = this.state.editedStockDescription;
    stockRequest.category = this.state.editedStockCategory;
    stockRequest.type = this.state.editedStockType;
    stockRequest.quantity = this.state.editedStockQuantity;

    await api("stockApiV1StockCreate", stockRequest).then(res => {
      if (res.data.lastUpdatedDateTime) {
        res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
      }

      let stockResponse = CloudService.StockResponse.constructFromObject(
        res.data
      );
      console.log(stockResponse);

      if (stockResponse.errorCode === 0) {
        this.setState({
          stockEdited: false,
          stockAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Stock successfully created",
          life: 3000
        });
        let typeOfUpdate = 2;
        this.updateStockList(stockResponse, typeOfUpdate);
      } else {
        this.setState({ editLoaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the stock, please try again",
          life: 3000
        });
      }
    });
  };

  deleteStock = async () => {
    this.setState({ loaded: false });

    let stockRequest = new CloudService.StockRequest();
    stockRequest.codeTag = localStorage.getItem("codeTag");
    stockRequest.userId = localStorage.getItem("userId");
    stockRequest.id = this.state.stockId;
    stockRequest.lastUpdatedDateTime = this.state.stockLastUpdatedDateTime;

    await api("stockApiV1StockDelete", stockRequest).then(res => {
      let stockResponse = CloudService.StockResponse.constructFromObject(
        res.data
      );
      console.log(stockResponse);

      if (stockResponse.errorCode === 0) {
        this.setState({
          stockSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Stock successfully deleted",
          life: 3000
        });
        let typeOfUpdate = 3;
        this.updateStockList(stockResponse, typeOfUpdate);
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the stock, please try again",
          life: 3000
        });
      }
    });
  };

  updateStockList = (apiResponse, type) => {
    let stockList = this.state.stockList;
    let i = 0;

    if (type === 2) {
      stockList.push({
        id: apiResponse.id,
        lastUpdatedDateTime: apiResponse.lastUpdatedDateTime,
        stockCode: this.state.editedStockStockCode,
        description: this.state.editedStockDescription,
        category: this.state.editedStockCategory,
        type: this.state.editedStockType,
        quantity: this.state.editedStockQuantity
      });
    } else {
      this.state.stockList.forEach(e => {
        if (apiResponse.id === e.id || this.state.stockId === e.id) {
          if (type === 1) {
            stockList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
            stockList[i].stockCode = this.state.editedStockStockCode;
            stockList[i].description = this.state.editedStockDescription;
            stockList[i].category = this.state.editedStockCategory;
            stockList[i].type = this.state.editedStockType;
            stockList[i].quantity = this.state.editedStockQuantity;
          }
          if (type === 3) {
            stockList.splice(i, 1);
          }
        }
        i++;
      });
    }

    this.setState(
      { stockList: stockList, loaded: true, editLoaded: true },
      () => {
        console.log(this.state.stockList);
        this.reselectStock();
      }
    );
  };

  selectStock = data => {
    this.setState(
      {
        selectedStock: data,
        stockCategory: data.category,
        stockCodeTag: data.codeTag,
        stockDescription: data.description,
        stockId: data.id,
        stockLastUpdatedDateTime: data.lastUpdatedDateTime,
        stockQuantity: data.quantity,
        stockStockCode: data.stockCode,
        stockType: data.type,
        stockUserId: data.userId
      },
      () => {
        console.log(this.state.selectedStock);
      }
    );
  };

  editStock = () => {
    if (this.state.stockAdded === true) {
      this.setState({
        editedStockCategory: "",
        editedStockDescription: "",
        editedStockQuantity: "",
        editedStockStockCode: "",
        editedStockType: ""
      });
    } else {
      this.setState({
        editedStockCategory: this.state.stockCategory,
        editedStockDescription: this.state.stockDescription,
        editedStockQuantity: String(this.state.stockQuantity),
        editedStockStockCode: this.state.stockStockCode,
        editedStockType: this.state.stockType
      });
    }
  };

  reselectStock = () => {
    if (this.state.selectedStock) {
      this.state.stockList.forEach(e => {
        if (this.state.stockId === e.id) {
          this.setState(
            {
              stockSelected: true,
              stockEdited: false,
              stockAdded: false
            },
            () => {
              this.selectStock(e);
            }
          );
        }
      });
    }
  };

  checkRequiredFields = () => {
    let disable = false;

    if (
      this.state.editedStockStockCode &&
      this.state.editedStockDescription &&
      this.state.editedStockCategory &&
      this.state.editedStockType &&
      this.state.editedStockQuantity
    ) {
      disable = false;
    } else {
      disable = true;
    }

    return disable;
  };

  render() {
    const s = this.state;

    return (
      <div
        className="ui-g dashboard"
        style={s.editLoaded === false ? { pointerEvents: "none" } : {}}
      >
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <pr.Dialog
          header="Delete Stock"
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                icon="pi pi-check"
                onClick={() => {
                  this.setState({ stockDeleted: false });
                  this.deleteStock();
                }}
                style={{
                  float: "right"
                }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ stockDeleted: false });
                }}
                style={{
                  float: "right"
                }}
              />
            </div>
          }
          visible={s.stockDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ stockDeleted: false })}
        >
          Are you sure you want to delete?
        </pr.Dialog>

        {s.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Card*/}
            {s.stockSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Stock Id: </b>
                    <label>{fo.formatId(s.stockId) || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Stock Code: </b>
                    <label>{s.stockStockCode || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Category: </b>
                    <label>{s.stockCategory || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Type: </b>
                    <label>{s.stockType || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Description: </b>
                    <label>{s.stockDescription || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Quantity: </b>
                    <label>{s.stockQuantity || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Edit"
                    icon="pi pi-plus"
                    onClick={() => {
                      this.setState(
                        {
                          stockSelected: false,
                          stockEdited: true,
                          stockAdded: false
                        },
                        () => {
                          this.editStock();
                        }
                      );
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="Delete"
                    icon="pi pi-trash"
                    onClick={() => {
                      this.setState({ stockDeleted: true });
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="Close"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        stockSelected: false,
                        stockEdited: false,
                        stockAdded: false
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Card*/}
            {s.stockEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedStockStockCode || ""}
                        onChange={e =>
                          this.setState({
                            editedStockStockCode: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Stock Code *</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedStockDescription || ""}
                        onChange={e =>
                          this.setState({
                            editedStockDescription: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Description *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedStockCategory || ""}
                        onChange={e =>
                          this.setState({
                            editedStockCategory: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Category *</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedStockType || ""}
                        onChange={e =>
                          this.setState({
                            editedStockType: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Type *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedStockQuantity || ""}
                        onChange={e =>
                          this.setState({
                            editedStockQuantity: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Quantity *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    disabled={this.checkRequiredFields()}
                    label="Save"
                    icon={
                      s.editLoaded === false
                        ? "pi pi-spin pi-spinner"
                        : "pi pi-check"
                    }
                    onClick={() => {
                      s.stockAdded === true
                        ? this.addStock()
                        : this.updateStock();
                    }}
                    style={{
                      float: "right"
                    }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={() => {
                      s.templateAdded === true
                        ? this.setState({
                            stockSelected: false,
                            stockEdited: false,
                            stockAdded: false
                          })
                        : this.setState({
                            stockSelected: true,
                            stockEdited: false,
                            stockAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Table*/}
            <div className="ui-g-12 card">
              <pr.DataTable
                value={s.stockList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      stockSelected: true,
                      stockEdited: false,
                      stockAdded: false
                    },
                    () => {
                      this.selectStock(e.data);
                    }
                  );
                }}
                selection={s.selectedStock}
                header={
                  <div className="ui-g">
                    <div className="ui-g-12">
                      <pr.Button
                        className="secondary-btn"
                        label="Create New"
                        icon="pi pi-pencil"
                        onClick={() => {
                          this.setState(
                            {
                              stockSelected: false,
                              stockEdited: true,
                              stockAdded: true,
                              selectedStock: ""
                            },
                            () => {
                              this.editStock();
                            }
                          );
                        }}
                        style={{ float: "right" }}
                      />
                    </div>
                    <div className="ui-g-12">
                      <label className="header-label">Stock</label>
                    </div>
                  </div>
                }
                emptyMessage="No Stock"
                rows={100}
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
              >
                <pr.Column
                  field="id"
                  header="Stock Id"
                  body={e => {
                    return fo.formatId(e.id);
                  }}
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="stockCode"
                  header="Stock Code"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="category"
                  header="Category"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="type"
                  header="Type"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="description"
                  header="Description"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="quantity"
                  header="Quantity"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
              </pr.DataTable>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Stock/Stock.js